import { Link } from "@tanstack/react-router";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center">
      <div className="max-w-md space-y-3">
        <p className="text-xs font-semibold uppercase tracking-widest text-(--brand)">
          404
        </p>
        <h1 className="text-2xl font-bold text-foreground">Page not found</h1>
        <p className="text-sm text-muted-foreground">
          The page you’re looking for doesn’t exist. Head back to your
          dashboard.
        </p>
        <Link
          to="/dashboard"
          className="inline-flex items-center justify-center rounded-md border border-border bg-card px-4 py-2 text-xs font-semibold text-foreground hover:bg-muted/60 transition-colors"
        >
          Go to dashboard
        </Link>
      </div>
    </div>
  );
}
